<template>
  <div>
    <section class="page-content">
      <div class="row">
        <div class="col-md-12">
          <article class="title-section form-section">
            <h1 class="page-title text-center">Apply Now!</h1>
            <p class="page-desc text-center">Individual Real Estate Appraiser's E&O</p>
            <img
              src="../../../public/assets/images/calc.png"
              class="title-section-img"
              alt="background image"
            >
          </article>
          <article class="d-flex flex-column align-items-center px-4 pb-5 form-section">
            <p class="text-center" style="max-width: 795px; margin-bottom: 34px;">
              This policy applies only to claims first made against the insured during the policy period or discovery period. The limit of liability available to pay judgements or settlements shall be reduced by payment of defense costs. Defense costs are subject to the applicable retention. Please read and review the policy carefully.
            </p>
            <div class="d-flex" style="max-width: 651px;">
              <i class="legalese-fa fas fa-info-circle"></i>
              <div class="d-flex flex-column">
                <p class="more-desc-p text-center flex" style="max-width: 651px;">
                  Instructions: this Self-Rating Application is for an individual appraiser who performs 100% Real Estate Appraisals work. Please note that coverage will only apply to services rendered by the applicant.
                </p>
                <p class="font-weight-bold">
                  The term "Applicant" shall mean all natural persons proposed for coverage.
                </p>
              </div>
            </div>
          </article>
          <form action @submit.prevent="next">
            <article class="form-heading title-section form-section flex">
              <h2 class="form-title">Personal</h2>
              <p style="max-width: 350px; z-index: 1;" class="mx-4">
                Enter the name of the individually licensed applicant along with a business name (if any) and provide a street address for your business (alternate mailing address such as a PO Box and administrative contacts should be provided in the space indicated below).​​​​​​​
              </p>
              <img
                src="../../../public/assets/images/glasses.png"
                class="title-section-img form-title-img"
                alt="background image"
              >
            </article>
            <article class="input-section form-section">
              <div class="pt-0" style="padding-right: 56px;">
                <div class="row pb-3">
                  <div class="col-md-6">
                    <label for class="orep-label mb-0 ml-1">
                      Name of Appraiser:
                    </label>
                    <input
                      type="text"
                      name="fullLegalNameOfAppraiser"
                      v-model="individualAppraiser.fullLegalNameOfAppraiser"
                      class="orep-text-input w-100"
                      v-validate="'required'"
                      @input="validateBeforeSubmit()"
                      :disabled="state.fullLegalNameOfAppraiserValid"
                    >
                    <span
                      v-show="errors.has('fullLegalNameOfAppraiser')"
                      class="help is-danger form-errors text-danger"
                    >{{ errors.first('fullLegalNameOfAppraiser') | filterText }}</span>
                  </div>
                  <div class="col-md-6">
                    <label for class="orep-label mb-0 ml-1">
                      Business Name:
                    </label>
                    <input
                      type="text"
                      name="businessNameOfAppraiser"
                      v-model="individualAppraiser.businessNameOfAppraiser"
                      class="orep-text-input w-100"
                    >
                  </div>
                </div>
                <div class="row pb-3">
                  <div class="col-md-6">
                    <label for class="orep-label mb-0 ml-1">
                      Address:
                    </label>
                    <input
                      type="text"
                      name="address"
                      v-model="individualAppraiser.customer.address"
                      class="orep-text-input w-100"
                      v-validate="'required'"
                      @input="validateBeforeSubmit()"
                    >
                    <span
                      v-show="errors.has('address')"
                      class="help is-danger form-errors text-danger"
                    >{{ errors.first('address') | filterText }}</span>
                  </div>
                  <div class="col-md-6">
                    <label for class="orep-label mb-0 ml-1">
                      City:
                    </label>
                    <input
                      type="text"
                      name="city"
                      v-model="individualAppraiser.customer.city"
                      class="orep-text-input w-100"
                      v-validate="'required'"
                      @input="validateBeforeSubmit()"
                    >
                    <span
                      v-show="errors.has('city')"
                      class="help is-danger form-errors text-danger"
                    >{{ errors.first('city') | filterText }}</span>
                  </div>
                </div>
                <div class="row pb-3">
                  <div class="col-md-4">
                    <label for class="orep-label mb-0 ml-1">
                      State:
                    </label>
                    <select
                      class="orep-select w-100"
                      style="height: 40px; width: 383px;"
                      name="state"
                      v-model="individualAppraiser.customer.state"
                      v-validate="'required'"
                      @change="validateBeforeSubmit()"
                    >
                      <option v-for="(item, key) in states" :value="key">
                        {{item}}
                      </option>
                    </select>
                    <span
                      v-show="errors.has('state')"
                      class="help is-danger form-errors text-danger"
                    >{{ errors.first('state') | filterText }}</span>
                  </div>
                  <div class="col-md-4">
                    <label for class="orep-label mb-0 ml-1">
                      ZIP Code:
                    </label>
                    <input
                      type="text"
                      name="zipCode"
                      v-model="individualAppraiser.customer.zipCode"
                      class="orep-text-input w-100"
                      v-validate="'required'"
                      @input="validateBeforeSubmit()"
                    >
                    <span
                      v-show="errors.has('zipCode')"
                      class="help is-danger form-errors text-danger"
                    >{{ errors.first('zipCode') | filterText }}</span>
                  </div>
                  <div class="col-md-4">
                    <label for class="orep-label mb-0 ml-1">
                      Phone:
                    </label>
                    <input
                      type="text"
                      name="phone"
                      v-model="individualAppraiser.customer.phone"
                      class="orep-text-input w-100"
                      v-validate="'required'"
                      @input="validateBeforeSubmit()"
                    >
                    <span
                      v-show="errors.has('phone')"
                      class="help is-danger form-errors text-danger"
                    >{{ errors.first('phone') | filterText }}</span>
                  </div>
                </div>
                <div class="row pb-3">
                  <div class="col-md-6">
                    <label for class="orep-label mb-0 ml-1">
                      County:
                    </label>
                    <input
                      type="text"
                      name="county"
                      v-model="individualAppraiser.customer.county"
                      class="orep-text-input w-100"
                      v-validate="'required'"
                      @input="validateBeforeSubmit()"
                    >
                    <span
                      v-show="errors.has('county')"
                      class="help is-danger form-errors text-danger"
                    >{{ errors.first('county') | filterText }}</span>
                  </div>
                  <div class="col-md-6">
                    <label for class="orep-label mb-0 ml-1">
                      Primary Email Address:
                    </label>
                    <input
                      type="email"
                      name="email"
                      autocomplete="email"
                      v-model="individualAppraiser.customer.email"
                      class="orep-text-input w-100"
                      v-validate="'required|email'"
                      @input="validateBeforeSubmit()"
                    >
                    <span
                      v-show="errors.has('email')"
                      class="help is-danger form-errors text-danger"
                    >{{ errors.first('email') | filterText }}</span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-4">
                    <label for class="orep-label mb-0 ml-1">
                      Desired Effective Date:
                    </label>
                    <datepicker
                      name="effectiveDate"
                      v-model="individualAppraiser.effectiveDate"
                      v-validate="'required'"
                      format="MM/dd/yyyy"
                      input-class="orep-text-input w-75"
                      @input="validateBeforeSubmit()"
                      :disabled="state.effectiveDateValid"
                      :clearButton="false"
                      :value="computedDates"
                    ></datepicker>
                    <span
                      v-show="errors.has('effectiveDate')"
                      class="help is-danger form-errors text-danger"
                    >{{ errors.first('effectiveDate') | filterText }}</span>
                  </div>
                  <div class="col-md-4">
                    <label for class="orep-label mb-0 ml-1">
                      Retroactive Date:
                    </label>
                    <datepicker
                      name="retroactiveDate"
                      v-model="individualAppraiser.retroactiveDate"
                      format="MM/dd/yyyy"
                      input-class="orep-text-input w-75"
                      :disabled="state.retroactiveDateValid"
                      :clearButton="false"
                      :value="computedDates"
                      :use-utc=true
                    ></datepicker>

                  </div>
                  <div class="d-flex align-items-end col-md-4">
                    <div class="radio orep-radio-wrapper solo-checkbox">
                      <label class="mb-0">
                        <input
                          type="checkbox"
                          name="noPriorCoverage"
                          class="orep-radio w-40"
                          v-model="individualAppraiser.noPriorCoverage"
                        >
                        <span class="radio-span solo-checkbox-span">
                          No Prior Coverage
                        </span>
                      </label>
                    </div>
                  </div>
                </div>
                <div class="row pb-3">
                  <div class="col col-md-4 mt-1 small">
                    <span>We cannot backdate coverage.</span>
                  </div>
                  <div class="col mt-1 small">
                    <span>
                      If you have current coverage, but don't know your Retroactive Date, please leave blank.
                    </span>
                  </div>
                </div>

                  <div class="col mt-1 small">
                    <p class="input-info">
                      <i class="fas fa-exclamation-triangle not-eligible"></i><span class="not-eligible-text">
                  If you are new to OREP, please email a copy of your Expiring Declarations Page to
                   <strong><a href="mailto:appraisers@orep.org" target="_top">appraisers@orep.org</a></strong>
                </span>
                    </p>
                  </div>

              </div>
            </article>
            <article class="input-section form-section">
              <label for class="orep-label" style="max-width: 954px;">
                Please describe any alternate business names, mailing/billing addresses, or administrative contact information related to business activities other than the official ones listed above.  If none, please leave it empty.
              </label>
              <input
                type="text"
                name="additionalBusinessInfo"
                v-model="individualAppraiser.additionalBusinessInfo"
                class="orep-text-input"
              >
            </article>
            <article class="input-section form-section">
              <div class="radio orep-radio-wrapper solo-checkbox">
                <label>
                  <input
                    type="checkbox"
                    name="emailPolicy"
                    class="orep-radio w-40"
                    v-model="individualAppraiser.emailPolicy"
                  >
                  <span class="radio-span solo-checkbox-span">
                    In lieu of mailing my policy, please Email my policy to the above address. I agree to accept an electronic copy of my application with my policy.
                  </span>
                </label>
              </div>
              <div class="radio orep-radio-wrapper solo-checkbox">
                <label>
                  <input
                    type="checkbox"
                    name="placeCoverageWithAlternativeInsuranceCompany"
                    class="orep-radio w-40"
                    v-model="individualAppraiser.placeCoverageWithAlternativeInsuranceCompany"
                  >
                  <span class="radio-span solo-checkbox-span">
                    In lieu of completing multiple applications, I agree for this application to be used to place coverage with an alternate insurance company offering better coverage or lower rates for a comparable product.
                  </span>
                </label>
              </div>
            </article>
          </form>
        </div>
      </div>
    </section>
    <div>
      <div class="row">
        <div class="col-md-12">
          <section class="flex wrap bottom-section">
            <article class="orep-pagination">
              <button class="pagination-dots pagination-current"></button>
              <button
                class="pagination-dots"
                @click="navigateToNext('individual-appraiser-2')"
                :disabled="!state.pageOneIsValid">
              </button>
              <button
                class="pagination-dots"
                @click="navigateToNext('individual-appraiser-3')"
                :disabled="!state.pageOneIsValid || !state.pageTwoIsValid">
              </button>
              <button
                class="pagination-dots"
                @click="navigateToNext('individual-appraiser-4')"
                :disabled="!state.pageOneIsValid || !state.pageTwoIsValid || !state.pageThreeIsValid">
              </button>
              <button
                class="pagination-dots"
                @click="navigateToNext('individual-appraiser-5')"
                :disabled="!state.pageOneIsValid || !state.pageTwoIsValid || !state.pageThreeIsValid || !state.pageFourIsValid">
              </button>
              <button
                class="pagination-dots"
                @click="navigateToNext('individual-appraiser-6')"
                :disabled="!state.pageOneIsValid || !state.pageTwoIsValid || !state.pageThreeIsValid || !state.pageFourIsValid || !state.pageFiveIsValid">
              </button>
            </article>
            <button type="submit" :disabled="!state.pageOneIsValid"
                    :class="{submitDisabled: !state.pageOneIsValid}" class="next-btn mont spaced pull-right" @click="navigateToNext('individual-appraiser-extra-page')"
            v-if="individualAppraiser.customer.state === 'NH' || individualAppraiser.customer.state === 'IL' || individualAppraiser.customer.state === 'MT' || individualAppraiser.customer.state ==='VA'">Next</button>

            <button type="submit" :disabled="!state.pageOneIsValid"
              :class="{submitDisabled: !state.pageOneIsValid}" class="next-btn mont spaced pull-right" @click="pageOneSubmit('individual-appraiser-2')"
            v-else >Next</button>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import Datepicker from 'vuejs-datepicker';
import {APP_STATUS, STATES, STATUS} from "../../utils/constants";
var moment = require('moment')

export default {
  name: "individual-appraiser-1",
  computedDates () {
    return moment(this.value).format('YYYY-MM-D')
  },
  data() {
    return {
      states: STATES
    };
  },
  computed: {
    individualAppraiser() {
      return this.$store.state.individualAppraiser.individualAppraiser;
    },
    state() {
      return this.$store.state.individualAppraiser;
    },
    errorMsg() {
      return this.$store.state.individualAppraiser.errorMsg;
    }
  },

  watch: {
    errorMsg: {
      handler() {
        if (this.errorMsg) {
          this.$notify({
            group: 'error',
            type: 'error',
            title: 'Error',
            text: this.errorMsg
          });
        }
      }
    }
  },

  methods: {
    navigateToNext(routeName) {
      this.$router.push({
        name: routeName
      });
    },
    pageOneSubmit(routeName) {
      this.loading = true;
      this.individualAppraiser.customer.contactName = this.state.individualAppraiser.fullLegalNameOfAppraiser;
      this.individualAppraiser.customer.companyName = this.state.individualAppraiser.businessNameOfAppraiser;
      this.individualAppraiser.customer.isIndividualAppraiser = 'True';
      this.individualAppraiser.customer.appStatus = APP_STATUS.Partially_Completed;
      this.$store.dispatch('individualAppraiser/createCustomer');

      // this.$router.push({
      //   name: routeName,
      // });
    },

    navigateToNextCustomLink() {
      window.open("https://orep.org/wp-content/uploads/2019/09/IL_NH_MT-Individual-Appraiser-Application.pdf", "_blank");
    },
    validateBeforeSubmit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.state.pageOneIsValid = true;
          return;
        }
        this.state.pageOneIsValid = false;
      });
    }
  },

  filters: {
    filterText(x) {
      if (x !== undefined) {
        if (x.indexOf("req") !== -1) {
          return "This field is required";
        } else {
          return x.replace("_", " ");
        }
      }
    }
  },

  mounted() {
    const params = this.$route.query;
    if (params && params.filter) {
      this.state.individualAppraiser.applicantRequestFrom = params.filter;
    }
    $('html, body').animate({
        scrollTop: $('.page-content').offset().top
    }, 500);
  },

  components: {
    Datepicker
  }
};
</script>

<style scoped>
  .page-desc {
    width: 295px;
    height: 45px;
  }
  .form-title {
    font-size: 35px !important;
  }
  .w-40 {
    flex: 0 0 40px;
  }
</style>
